import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Products from "./components/Products";
import About from "./components/About";
import Footer from "./components/Footer";
import Recipe from "./components/Recipe";


function App() {
  return (
    <div className="bg-white text-gray-900 flex flex-col">
      <Navbar />
      <Hero />
      <Products />
      <Recipe />
      <About />
      <Footer />
    </div>
  );
}

export default App;
